<!-- @format -->

<template>
  <div class="home">
    <div class="ui sixteen column very padded grid centered">
      <div class="five wide column" style="padding: 1em 0em 0em 2em">
        <div>
          <div class="ui segment">
            <div class="ui attached message">
              <div class="content">
                <div class="header">Portfolio Details</div>
              </div>
            </div>
            <div class="ui attached segment">
              <div class="ui form">
                <div class="ui field">
                  <label>Portfolio Name</label>
                  <input v-model="newCustomPortfolioRequest.portfolioName" />
                </div>
              </div>
              <br />
              <div class="ui field">
                <label>
                  <strong>Link to Risk Profile</strong>
                </label>
                <v-select
                  @input="calculateStats"
                  label="riskProfileName"
                  v-model="newCustomPortfolioRequest.riskProfile"
                  :options="riskProfiles"
                ></v-select>
              </div>
              <div class="ui divider"></div>
              <div class="ui field">
                <label>
                  <strong>Portfolio Allocation </strong>-
                  <span
                    :style="
                      customPortfolioTotalWeight != 100
                        ? 'color: red'
                        : 'color: green'
                    "
                  >
                    {{ customPortfolioTotalWeight }}%
                  </span>
                </label>
                <div class="ui form fluid">
                  <table class="ui very compact basic table">
                    <tr
                      v-for="p in newCustomPortfolioRequest.portfolioWeight"
                      :key="p.id"
                    >
                      <td>
                        {{ p.underlyingPortfolio.portfolioName }}
                      </td>
                      <td>
                        <div style="float: right" class="ui field">
                          <input
                            :disabled="
                              loading2 && customPortfolioTotalWeight == 100
                            "
                            @change="calculateStats"
                            v-model.number="p.weight"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2">
                        <div
                          class="ui primary button"
                          @click.prevent="saveCustomPortfolio"
                          v-if="
                            message == '' &&
                              customPortfolioTotalWeight == 100 &&
                              newCustomPortfolioRequest
                          "
                        >
                          Save
                        </div>
                        <div v-if="message != ''" class="ui positive message">
                          {{ message }}
                        </div>
                      </td>
                    </tr>
                  </table>

                  <router-link to="/customportfolios"
                    >Back to All Portfolios</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="eleven wide column" style="padding: 1em 2em 0em 2em">
        <div v-show="false" class="ui small secondary pointing menu">
          <a
            class="item"
            v-bind:class="{ active: tabRight == 1 }"
            @click.prevent="tabRight = 1"
            >Stats</a
          >
        </div>
        <div v-if="tabRight == 1">
          <div class="ui segment">
            <div class="ui sixteen column grid">
              <div class="ui row">
                <div class="three wide column">
                  <div class="ui very basic segment"></div>
                  <div class="ui vertical fluid tabular menu">
                    <a
                      :class="stats == 'riskReturn' ? 'active item' : 'item'"
                      @click.prevent="showStats('riskReturn')"
                      >Risk Return</a
                    >
                    <a
                      :class="stats == 'positions' ? 'active item' : 'item'"
                      @click.prevent="showStats('positions')"
                      >Positions</a
                    >
                    <a
                      :class="stats == 'aa' ? 'active item' : 'item'"
                      @click.prevent="showStats('aa')"
                      >Asset Allocation
                    </a>
                    <a
                      :class="stats == 'performance' ? 'active item' : 'item'"
                      @click.prevent="showStats('performance')"
                      >Performance
                    </a>
                  </div>
                </div>
                <div class="thirteen wide column">
                  <div
                    :class="
                      'ui basic ' +
                        (loading2 && customPortfolioTotalWeight == 100
                          ? 'loading'
                          : '') +
                        ' segment'
                    "
                  >
                    <h1 class="ui sub header">
                      <span style="font-size: large"
                        >{{ portfolioView.portfolioName }}
                      </span>
                      <br />
                      <span class="ui sub header"
                        >Portfolio Details
                        <small v-if="portfolioView.yearlyPerformances"
                          >as at
                          {{
                            portfolioView.yearlyPerformances[
                              portfolioView.yearlyPerformances.length - 1
                            ].endDate
                          }}</small
                        ></span
                      >
                    </h1>
                  </div>
                  <div v-if="stats == 'aa'">
                    <ChartBarAaV2
                      v-if="currency == 'ZAR' && contains(aaType, 'Simple')"
                      :appearanceSettings="appearanceSettings"
                      :selectedPortfolio="portfolioView"
                      :show="true"
                      v-show="true"
                    />

                    <ChartBarAaV2Extended
                      v-if="currency == 'ZAR' && contains(aaType, 'Extended')"
                      :appearanceSettings="appearanceSettings"
                      :selectedPortfolio="portfolioView"
                      :show="true"
                      v-show="true"
                    />
                    <ChartBarAaV2Usd
                      v-if="currency == 'USD'"
                      :appearanceSettings="appearanceSettings"
                      :selectedPortfolio="portfolioView"
                      :show="true"
                      v-show="true"
                    />
                  </div>
                  <div v-if="stats == 'positions'">
                    <Positions
                      :appearanceSettings="appearanceSettings"
                      :selectedPortfolio="portfolioView"
                      :show="true"
                      v-show="true"
                    />
                  </div>
                  <div v-if="stats == 'performance'">
                    <PerformanceV2
                      v-if="currency == 'ZAR'"
                      :appearanceSettings="appearanceSettings"
                      :selectedPortfolio="portfolioView"
                      :show="true"
                      v-show="true"
                    />
                    <PerformanceV2Usd
                      v-if="currency == 'USD'"
                      :appearanceSettings="appearanceSettings"
                      :selectedPortfolio="portfolioView"
                      :show="true"
                      v-show="true"
                    />
                  </div>
                  <div v-if="stats == 'riskReturn'">
                    <div class="ui segment">
                      <div class="ui blue ribbon label">Risk Return</div>

                      <DxChart
                        id="chartRiskReturnSelected"
                        :customize-point="customizePoint"
                        :data-source="chartRiskReturn"
                      >
                        <DxSize :height="190" />
                        <dx-legend :visible="false">
                          <dx-font color="black" />
                        </dx-legend>

                        <DxCommonSeriesSettings type="scatter">
                          <DxPoint :visible="false" />
                          <DxLabel :visible="true">
                            <DxFormat :precision="2" type="fixedPoint" />
                          </DxLabel>
                        </DxCommonSeriesSettings>

                        <DxSeries
                          argument-field="annualisedStandardDeviation"
                          value-field="expectedReturn"
                        ></DxSeries>
                        <DxSeries
                          argument-field="annualisedStandardDeviation2"
                          value-field="expectedReturn2"
                        ></DxSeries>
                        <DxValueAxis title="Return (%)" />
                        <DxArgumentAxis title="Standard Deviation (%)" />
                      </DxChart>
                      <br />
                      <div class="ui horizontal divider">Risk Return</div>

                      <table
                        style="font-size: small"
                        class="ui very compact table"
                      >
                        <thead>
                          <tr>
                            <th>Description</th>
                            <th>Risk</th>
                            <th style="vertical-align: center">Return %</th>
                            <th style="vertical-align: center">Stand Dev%</th>
                          </tr>
                        </thead>
                        <tr
                          v-for="a in order(
                            chartRiskReturn,
                            'comboExpectedReturn',
                            'asc'
                          )"
                        >
                          <td>
                            <span v-if="a.expectedReturn2"
                              >🔴 {{ a.portfolioName }}</span
                            >
                            <span v-else>{{ a.portfolioName }}</span>
                          </td>
                          <td>{{ a.riskProfile.riskProfileName }}</td>
                          <td style="vertical-align: center">
                            <span v-if="a.expectedReturn">
                              {{ formatNr(a.expectedReturn, "0,0.00") }}
                            </span>
                            <span v-else>
                              {{ formatNr(a.expectedReturn2, "0,0.00") }}
                            </span>
                          </td>
                          <td style="vertical-align: center">
                            <span v-if="a.annualisedStandardDeviation">
                              {{
                                formatNr(
                                  a.annualisedStandardDeviation,
                                  "0,0.00"
                                )
                              }}
                            </span>
                            <span v-else>
                              {{
                                formatNr(
                                  a.annualisedStandardDeviation2,
                                  "0,0.00"
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";

import {
  getCustomPortfolios,
  getCustomPortfolio,
  getRiskProfiles,
  calculateCustomPortfolioStats,
  createOrUpdateCustomPortfolio,
  getPartnerSettings,
} from "@/gateway";
import ChartBarAaV2 from "@/components/ChartBarAaV2.vue";
import ChartBarAaV2Extended from "@/components/ChartBarAaV2Extended.vue";
import ChartBarAaV2Usd from "@/components/ChartBarAaV2Usd.vue";
import Positions from "@/components/PositionsV2.vue";

import PerformanceV2 from "@/components/PerformanceV2.vue";
import PerformanceV2Usd from "@/components/PerformanceV2Usd.vue";
//import { getRiskProfiles } from "../utils/riskprofiles";
import {
  DxChart,
  DxSize,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxLabel,
  DxFont,
  DxFormat,
  DxConstantLine,
} from "devextreme-vue/chart";
import vSelect from "vue-select";
export default {
  name: "CustomPortfolioList",
  components: {
    vSelect,
    DxChart,
    DxSize,
    DxSeries,
    DxFormat,
    DxConstantLine,
    DxArgumentAxis,
    DxValueAxis,
    DxCommonSeriesSettings,
    DxLegend,
    DxLabel,
    DxFont,
    Positions,
    ChartBarAaV2,
    ChartBarAaV2Extended,
    ChartBarAaV2Usd,
    PerformanceV2,
    PerformanceV2Usd,
  },
  watch: {},
  computed: {
    chartAa: function() {
      let finalAa = [];
      // for (var i = 0; i < this.chartProjections.length; i++) {
      if (this.customPortfolioTotalWeight == 100) {
        let p = this.portfolioView;
        finalAa.push({
          value: p.assetAllocation.localCash,
          name: "SA Cash",
        });
        finalAa.push({
          value: p.assetAllocation.localBonds,
          name: "SA Bonds",
        });
        finalAa.push({
          value: p.assetAllocation.localProperty,
          name: "SA Property",
        });
        finalAa.push({
          value: p.assetAllocation.localEquity,
          name: "SA Equity",
        });
        finalAa.push({
          value: p.assetAllocation.foreignCash,
          name: "Gbl Cash",
        });
        finalAa.push({
          value: p.assetAllocation.foreignBonds,
          name: "Gbl Bonds",
        });
        finalAa.push({
          value: p.assetAllocation.foreignProperty,
          name: "Gbl Property",
        });
        finalAa.push({
          value: p.assetAllocation.foreignEquity,
          name: "Gbl Equity",
        });
      }
      return finalAa;
    },
    allPortfolioStats: function() {
      let final = [];
      if (this.customPortfolioTotalWeight == 100) {
        for (var i = 0; i < this.allPortfolios.length; i++) {
          var v = _.cloneDeep(this.allPortfolios[i]);
          v.color = "blue";
          v.expectedReturn = v.expectedReturn * 100;
          v.comboExpectedReturn = v.expectedReturn * 100;
          v.annualisedStandardDeviation = v.annualisedStandardDeviation * 100;
          if (v.customPortfolioId != this.$route.params.id) final.push(v);
        }

        if (this.customPortfolioTotalWeight == 100) {
          let vw = _.cloneDeep(this.portfolioView);
          vw.expectedReturn = null;
          vw.annualisedStandardDeviation = null;
          vw.expectedReturn2 = this.portfolioView.expectedReturn * 100;
          vw.comboExpectedReturn = this.portfolioView.expectedReturn * 10000;
          vw.annualisedStandardDeviation2 =
            this.portfolioView.annualisedStandardDeviation * 100;

          vw.color = "red";
          final.push(vw);
        }
        let ff = _.orderBy(final, ["comboExpectedReturn"], ["asc"]);
        return ff;
      }
      return this.allPortfolios;
    },
    customPortfolioTotalWeight() {
      let total = 0;
      if (this.newCustomPortfolioRequest.portfolioWeight) {
        for (
          var i = 0;
          i < this.newCustomPortfolioRequest.portfolioWeight.length;
          i++
        ) {
          if (this.newCustomPortfolioRequest.portfolioWeight[i].weight)
            total += this.newCustomPortfolioRequest.portfolioWeight[i].weight;
        }
      }
      return total;
    },
  },
  data() {
    return {
      appearanceSettings: {},
      aaType: "Simple",
      loading: false,
      loading2: false,
      showSaveButton: false,
      stats: "riskReturn",
      message: "",
      chartRiskReturn: null,
      chartAaData: null,
      // inputs,
      portfolioName: "",
      riskProfile: null,
      riskProfiles: [],
      newCustomPortfolioRequest: null,
      allPortfolios: [],
      //
      tabLeft: 1,
      tabRight: 1,
      status: 1,
      result: null,
      portfolioView: null,
    };
  },
  methods: {
    contains(source, text) {
      if (source.includes(text)) return true;
      else return false;
    },
    async showStats(val) {
      this.loading = true;
      this.loading2 = true;
      this.stats = val;
      await this.calculateStats();
    },
    map: function(arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    flatten: function(arr) {
      return _.flattenDeep(arr);
    },
    order: function(arr, val1, value2) {
      return _.orderBy(arr, [val1], [value2]);
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    async init() {
      let cp = await getRiskProfiles({ currency: this.$route.params.currency });
      this.currency = this.$route.params.currency;
      if (cp) {
        this.riskProfiles = cp.result;
        await this.getResults();

        let pf = await getCustomPortfolios({
          mapToPortfolioView: true,
          currency: this.$route.params.currency,
        });

        if (pf) {
          this.allPortfolios = pf.portfolioViews;
          await this.calculateStats({ currency: this.$route.params.currency });
        }
      }
    },
    async calculateStats() {
      this.showSaveButton = false;
      this.loading = true;
      await this.calculateStatsAsync();
    },
    async calculateStatsAsync() {
      this.loading = true;
      this.loading2 = true;
      if (this.customPortfolioTotalWeight == 100) {
        this.message = "";
        var newRequest = _.cloneDeep(this.newCustomPortfolioRequest);
        this.newCustomPortfolioRequest = null;
        this.portfolioView = null;
        var response = await calculateCustomPortfolioStats({
          currency: this.$route.params.currency,
          customPortfolio: newRequest,
          loadUnderlyingData: true,
          loadUnderlyingType: this.stats,
          aaType: this.aaType,
        });

        if (response) {
          console.log("done...", this.loading);
          this.result = response.result;
          this.newCustomPortfolioRequest = response.result;

          this.portfolioView = response.portfolioView;
          this.portfolioName = response.result.portfolioName;
          this.riskProfile = response.result.riskProfile;

          this.chartAaData = this.chartAa;
          this.chartRiskReturn = this.allPortfolioStats;
          this.loading = false;
          this.loading2 = false;
          this.showSaveButton = true;
          console.log("done 2...", this.loading);
        }
      } else {
        console.log("done 4...", this.customPortfolioTotalWeight, this.loading);
        this.loading = false;
        this.showSaveButton = true;
      }
    },
    customizePoint(arg) {},
    async getResults() {
      this.loading = true;
      this.loading2 = true;
      let response = await getCustomPortfolio({
        id: this.$route.params.id,
        currency: this.$route.params.currency,
        aaType: this.aaType,
      });

      //console.log(response2);
      if (response) {
        this.result = response.result;
        this.newCustomPortfolioRequest = response.result;
        this.portfolioView = response.portfolioView;
        this.portfolioName = response.result.portfolioName;
        this.riskProfile = response.result.riskProfile;

        //this.loading = false;
      }
    },
    async saveCustomPortfolio() {
      if (this.newCustomPortfolioRequest) {
        let response = await createOrUpdateCustomPortfolio({
          id: this.$route.params.id,
          customPortfolio: this.newCustomPortfolioRequest,
        });
        if (response) {
          this.message = response.success
            ? "Success"
            : "Could not save. Tech team notified.";
          if (response.success)
            this.$router.push({
              name: "mapping",
              params: { id: response.result },
            });
        }
      }
    },
  },
  async mounted() {
    var partnerSettingsResponse = await getPartnerSettings();
    if (partnerSettingsResponse) {
      this.appearanceSettings =
        partnerSettingsResponse.partnerDefaultSettings.appearanceSettings;
      this.aaType =
        partnerSettingsResponse.partnerDefaultSettings.aaType || "Simple";
      this.init();
    }
  },
};
</script>
